"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.drawCircle = void 0;
exports.default = Circle;
var L = require("leaflet");
var createjs = require("@caddigital/easeljs/lib/easeljs");
var Rectangle_1 = require("./Rectangle");
var define = require("./define");
/**
 * TODO: REFACTOR THIS TO OWN FILE
 * convert latlng to point
 * */
var latlngToPoint = function (map, coords, pointCoordinate, zoom) {
    var p = map.project(pointCoordinate, zoom);
    var x = Math.round(p.x - coords.x);
    var y = Math.round(p.y - coords.y);
    // coords to tile space
    return new L.Point(x, y);
};
var drawCircle = function (graphics, x, y, bounds, scale, color) {
    if (typeof bounds.max === 'undefined' || typeof bounds.min === 'undefined') {
        return;
    }
    var g = graphics;
    var size = (bounds.max.y - bounds.min.y + bounds.max.x - bounds.min.x) / 2;
    g.clear();
    g.beginStroke(createjs.Graphics.getRGB(0, 0, 255, 0.3))
        .setStrokeStyle(1, 'round', 'bevel', 'round')
        .setStrokeDash([5, 5]);
    if (define.DEBUGGING) {
        g.drawRect(bounds.min.x, bounds.min.y, bounds.max.x - bounds.min.x, bounds.max.y - bounds.min.y);
    }
    g.endStroke();
    g.setStrokeStyle(define.BORDER_THICKNESS * scale, 'round', 'round');
    g.setStrokeDash([]);
    g.beginFill(color.fill);
    g.beginStroke(color.stroke);
    g.drawEllipse(x - size / 2, y - size / 2, size, size);
};
exports.drawCircle = drawCircle;
function Circle(map, rect, reverseX, reverseY, color, onClick) {
    var _this = this;
    createjs.Shape.call(this);
    this._reverseX = reverseX;
    this._reverseY = reverseY;
    var origin = map.getPixelOrigin();
    var zoom = map.getZoom();
    var topLeft = latlngToPoint(map, origin, rect.getNorthWest(), zoom);
    var bottomRight = latlngToPoint(map, origin, rect.getSouthEast(), zoom);
    var bounds = new L.Bounds([topLeft, bottomRight]);
    if (typeof bounds.max === 'undefined' || typeof bounds.min === 'undefined') {
        return;
    }
    var minX = !reverseX
        ? Math.min(bounds.min.x, bounds.max.x)
        : Math.max(bounds.min.x, bounds.max.x);
    var minY = !reverseY
        ? Math.min(bounds.min.y, bounds.max.y)
        : Math.max(bounds.min.y, bounds.max.y);
    var startPoint = new L.Point(minX, minY);
    var size = Math.abs(bounds.max.x - bounds.min.x + bounds.max.y - bounds.min.y) / 2;
    var min = startPoint.subtract(new L.Point(size / 2, size / 2));
    var max = startPoint.add(new L.Point(size / 2, size / 2));
    var updatedRect = new L.LatLngBounds([
        map.layerPointToLatLng(min),
        map.layerPointToLatLng(max)
    ]);
    Rectangle_1.default.call(this, map, updatedRect, color);
    this.onClick = onClick;
    this._draw = function () {
        var color = { fill: _this.fill, stroke: _this.stroke };
        if (_this._selected) {
            color = {
                fill: 'rgba(0, 255, 0, 0.8)',
                stroke: 'rgba(255, 0, 0, 0.8)'
            };
        }
        var context = _this.graphics;
        var bounds = _this._boundingBox;
        return (0, exports.drawCircle)(context, bounds.min.x + (bounds.max.x - bounds.min.x) / 2, bounds.min.y + (bounds.max.y - bounds.min.y) / 2, bounds, _this._scale, color);
    };
    return this;
}
Circle.prototype = new createjs.Shape();
